import Discord from './Discord';

export default Discord;
